import { ConnectedProps, connect } from "react-redux";
import { withRouter } from "react-router";

import { IStoreState } from "../../../../../../reducers/types";
import { actions as searchActions } from "../../../../../search/actions";
import * as searchSelectors from "../../../../../search/reducer/selectors";
import { StayTypesEnum } from "redmond";
import { actions } from "../../../../actions";
import {
  getCurrentSearchParams,
  getMapSearchCategories,
  getMapSearchCategoriesLoading,
} from "../../../../reducer";
import { ViewHotelsNearAutocomplete } from "./component";

export const mapDispatchToProps = {
  setHotelsSearchLocation: searchActions.setLocation,
  setVacationRentalsSearchLocation: searchActions.setVacationRentalsLocation,
  fetchInitialHotelsAvailability:
    actions.fetchInitialPremierCollectionAvailability,
  fetchInitialVacationRentalsAvailability:
    actions.fetchInitialVacationRentalsAvailability,
  setMapSearchQuery: actions.setMapSearchQuery,
  fetchPCLocationAutocomplete: searchActions.fetchPCLocationAutocomplete,
  fetchVRLocationAutocomplete: searchActions.fetchVRLocationAutocomplete,
};

export const mapStateToProps = (state: IStoreState) => {
  let loading = getMapSearchCategoriesLoading(state) ?? false;

  const stayType = searchSelectors.getStayType(state);

  return {
    stayType,
    currentMapSearchQuery: state.premierCollectionAvailability.mapSearchQuery,
    currentHotelsSearchLocation: searchSelectors.getLocation(state),
    currentVacationRentalsSearchLocaction:
      searchSelectors.getVacationRentalsLocation(state),
    rawLocationCategories: getMapSearchCategories(state),
    availabilitySearchParams: getCurrentSearchParams(state),
    loading,
  };
};

interface IOwnProps {
  [key: string]: any;
}

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  dispatchProps: typeof mapDispatchToProps,
  ownProps: IOwnProps
) => {
  const isVR = stateProps.stayType === StayTypesEnum.VacationRentals;

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    valueCategories: stateProps.rawLocationCategories,
    fetchValueCategories: isVR
      ? dispatchProps.fetchVRLocationAutocomplete
      : dispatchProps.fetchPCLocationAutocomplete,
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export const ConnectedViewHotelsNearLocationAutocomplete = connector(
  withRouter(ViewHotelsNearAutocomplete)
);

export type ViewHotelsNearLocationAutocompleteConnectorProps = ConnectedProps<
  typeof connector
>;
